import useFetch from 'elements/Hooks/useFetch'
import React from 'react'
import VendorQuotes from '../../../components/Purchasing/VendorQuotes/VendorQuotes'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import useTitle from '../../../elements/Hooks/useTitle'

export default function VendorQuotesCont() {
  const select = '_id,_key,code,quoteNo,rfq,enquiry,title,vendor,amount,vendorRep,company,companyRep,date,date,Status'

  const { data, fetching, fetch } = useFetch({ url: `vendorQuotes/?select=${select}`, queryKey: 'vendorQuotes' })
  const { list, company, onChangeCompany } = useListCompanyFilter(data, fetching)
  useTitle('Vendor Quotes')

  return (
    <VendorQuotes
      {...{
        list,
        fetching,
        fetch,
        company,
        onChangeCompany,
      }}
    />
  )
}
